import './style/index.js';

import _Filecard from './filecard';

export const Filecard = _Filecard;
export default Filecard;

export * from './type';
